import sdl from '@jds/react-generated-sdl/JDSAccordionList';
import type { JDSAccordionListProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, AccordionProps } from '../logic';

const Component = (props: AccordionProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    iconType = 'undefined',
    allowMultiple = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { iconType, allowMultiple, ...rest },
    'JDSAccordionList',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Accordion = withLogic(Component) as React.FC<AccordionProps> & {
  slotName?: string;
};

Accordion.displayName = 'Accordion';
Accordion.slotName = 'jds_accordion_list';

export { Accordion, type JDSAccordionListProps };
